import i18next from "i18next";
import {
  formatIncompletePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "libphonenumber-js/min";
import { getFromLocalStorage, setToLocalStorage } from "neetocommons/utils";
import * as yup from "yup";

import neetoIpLookupApi from "./apis/neeto_ip_lookup";
import { IP_LOOKUP_STORAGE_KEY, MAX_CACHE_AGE } from "./constants";

export const isPhoneNumberValid = (value = "", ...rest) =>
  isValidPhoneNumber(value, ...rest);

export const validation = (
  message = i18next.t("neetoMolecules.phoneNumberInput.validations.invalid")
) =>
  yup
    .string()
    .test("phoneNumber", message, phoneNumber =>
      phoneNumber ? isValidPhoneNumber(phoneNumber) : true
    );

export const getPhoneData = (value, defaultCountryCode) => {
  try {
    const parsedValue = parsePhoneNumber(value, defaultCountryCode);

    return {
      phoneNumber: parsedValue.number,
      international: parsedValue.formatInternational(),
      countryCode: parsedValue.country || defaultCountryCode,
    };
  } catch {
    return {
      phoneNumber: value,
      international: formatIncompletePhoneNumber(value, defaultCountryCode),
      countryCode: defaultCountryCode,
    };
  }
};

export const fetchLocationDetails = async () => {
  const stored = getFromLocalStorage(IP_LOOKUP_STORAGE_KEY);
  const { data, timestamp } = stored || {};
  const isCacheValid = timestamp && Date.now() - timestamp < MAX_CACHE_AGE;

  if (isCacheValid) return data;

  try {
    const details = await neetoIpLookupApi.fetchLocationDetails();
    const timestamp = Date.now();
    setToLocalStorage(IP_LOOKUP_STORAGE_KEY, { data: details, timestamp });

    return details;
  } catch {
    return data || null;
  }
};

export const isNumeric = char => char >= "0" && char <= "9";

export const preserveCursor = callback => event => {
  const start = event.target.selectionStart;
  const end = event.target.selectionEnd;
  const len = event.target.value.length;
  const result = callback(event);
  const delta = event.target.value.length - len;
  event.target.setSelectionRange(start + delta, end + delta);

  return result;
};
